<div id="stacked-bar"></div>